module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.b3b06989.otf";